module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"random":"Random","hint_mouse":"Hover the cursor over the avatar to edit.","hint_touch":"Click on the avatar to edit it.","save":"Save"},"de":{"random":"Zufällig","hint_mouse":"Fahre mit der Maus über das Profilbild zum Bearbeiten.","hint_touch":"Klicke auf das Profilbild zum Bearbeiten.","save":"Speichern"}}')
  delete Component.options._Ctor
}
